export default __webpack_public_path__ + "media/images/cta_blocks/youve_made_changes-77955263fb869c31067af20e763e2dca.jpg";